import styled from "styled-components";

export const TextInput = styled.input`
    font-family: 'Raleway', sans-serif;
    min-width:120px;
    width:100%;
    height:50px;
    outline: none;
    font-size:18px;
    font-weight:bold;
    text-align:center;
    *,*:focus,*:hover{
    outline:none;
    flex: 1 1 0px;
}
`